import React from "react";
//#region types
import { TodoFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
import { ReportConstants, TableConstants } from "utils/constants";
//#endregion
//#region components
import { DashboardButtonGroup, FilterButton, PageLayouts, ReloadEvent, TableContextProvider } from "components/common";
import AllToDoListView from "./listView";
import useTodoReportFilterDefinition from "../forms/useReportFilterDefinition";
import { useTodoService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const AllToDoReport: React.FC = () => {
  const todoService = useTodoService();
  const {
    filterFormFields: reportFilterDefinition,
    filterQueryStateHandler,
    apiToReportFilterFormatter,
  } = useTodoReportFilterDefinition();

  return (
    <ReloadEvent
      uniqueKey={ReportConstants.ReportKeys.Todo}
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout<TodoFormTypes.Filter>
          entityKey={0}
          hasPermissions={true}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Todo)}
          topRightButtons={<DashboardButtonGroup buttons={[<FilterButton />]} />}
          filterFields={reportFilterDefinition}
          initialFilter={{ snoozedOnly: false }}
          filterQueryStateHandler={filterQueryStateHandler}
          apiToReportFilterFormatter={apiToReportFilterFormatter}
          reportToAPIFilterFormatter={todoService.reportToAPIFilter}
          filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.Todo}
        >
          <TableContextProvider tableKey={TableConstants.TodoList}>
            <AllToDoListView reloadKey={reloadKey} reloadTodos={reload}></AllToDoListView>
          </TableContextProvider>
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default AllToDoReport;
